import { EntitiesStore } from './entities-store.abstract';
import { HttpClient } from '@angular/common/http';
import { PhaseStore } from './phase-store';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';


/**
 * Interface for member team of entries results.
 *
 * @export
 * @interface IMemberTeam
 */
export interface IMemberTeam {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  Qualification: boolean;
  Final: boolean;
}

/**
 * Category for team entries of competition.
 *
 * @export
 * @interface ICatTeamResult
 */
export interface ICatTeamResult {
  Code: string;
  Qualification: string;
  Rank: string;
  Members: IMemberTeam[];
}

/**
 * Team entries interface for TeamEntries endpoint.
 *
 * @export
 * @interface ITeamEntries
 */
export interface ITeamEntries {
  Country: string;
  CountryName: string;
  CatTeam: IMemberTeam[];
}

/**
 * Parameters interface for TeamEntries.
 *
 * @export
 * @interface IParamsTeamEntries
 */
export interface IParamsTeamEntries{
  CompId:string;
  CatId?:number;
  CatCode?:string;
  Noc?:string;
  Id?:string;
  fText?:string;
}

/**
 * Store of team entries endpoint.
 *
 * @export
 * @class TeamEntriesStore
 * @extends {EntitiesStore<ITeamEntries, IParamsTeamEntries>}
 */
export class TeamEntriesStore extends EntitiesStore<ITeamEntries, IParamsTeamEntries> {
  constructor(http: HttpClient, injector:Injector) {
    super('TEAMENTRIES', http, [{ entity: new CountryDependencyEntityStore(http, injector), params: { RBP: 'ALL' } }]);
  }

  /**
   * {@inheritdoc}
   *
   * @memberof TeamEntriesStore
   */
  getRequest(params, request_more){
    return super.getRequest(Object.assign(params, {'RBP':'ALL'}), request_more);
  }
}
